<template>
  <section class="w-100 mb-8">
    <h2
      class="f-24 sz-red--text font-weight-medium mb-5 text-center"
      :class="{ 'font-weight-bold': $vuetify.display.xs }"
    >
      {{ title }}
    </h2>
    <div class="d-flex flex-wrap justify-space-around">
      <div
        v-for="(item, index) in steps"
        :key="index"
        class="step"
      >
        <div
          class="mb-5 mt-sm-0 d-flex flex-column align-center"
          justify="center"
        >
          <v-img
            class="col col-12"
            position="center"
            :src="`${basePath}${item.imagePath}`"
            cover
            height="134"
            width="152"
          />
          <div
            v-orphans
            class="f-18 sz-primary-grey--text font-weight-medium my-2"
          >
            <h3 class="d-flex justify-center font-weight-medium">
              {{ $t('label.step') }} {{ index + 1 }}.
            </h3>
            <div
              :class="{'text-center': centerStepsText}"
              v-html="item?.text"
            />
            <div
              v-if="item?.additionalInfo && isCampaignUnderway"
              :class="{'text-center': centerStepsText}"
              v-html="item.additionalInfo"
            />
          </div>
        </div>
      </div>
    </div>
    <v-row
      no-gutters
      justify="space-around"
      class="mt-5"
    >
      <BaseButton
        :href="LINKS.guide"
        class="mb-4"
        variant="secondary"
      >
        {{ guideButtonText }}
      </BaseButton>
      <BaseButton
        v-if="!isCampaignUnderway"
        v-orphans
        :href="LINKS.aboutSzp"
      >
        {{ $t('label.readMoreSzp')
        }}
      </BaseButton>
    </v-row>
  </section>
</template>

<script setup lang="ts">
import BaseButton from '@/components/widgets/BaseButton.vue';
import { LINKS } from '@/constants/externalLinks';
import type { Step } from '@/types';
import useEditionStageStore from '@/stores/EditionStage';
import { storeToRefs } from 'pinia';

const editionStageStore = useEditionStageStore();

const {
    isCampaignUnderway
} = storeToRefs(editionStageStore);

type Props = {
  title?: string;
  steps?: Step[];
  guideButtonText?: string;
  centerStepsText?: boolean;
};

withDefaults(defineProps<Props>(), {
    title: '',
    steps: () => [],
    guideButtonText: '',
    centerStepsText: true
});

const basePath = process.env.VUE_APP_PUBLIC_PATH ?? '/';
</script>

<style lang="scss">
.step {
  width: 260px;
}
</style>
